module.exports = __webpack_public_path__ + "media/images/google-fb17d48cffc4c53665113c792a8effb0.svg";